import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import routes from './routes'

const router = new VueRouter({
  routes,
})
// 路由守衛
router.afterEach((to, from) => {
  console.log(to)

  document.body.scrollTop = document.documentElement.scrollTop = 0
  //将滚动条恢复到最顶端
  window.onunload = unload //兼容谷哥
})
router.beforeEach((to, from, next) => {
  console.log(11111)
  next()
})

function unload(e) {
  window.scrollTo(0, 0)
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js